// extracted by mini-css-extract-plugin
module.exports = {"header":"restricted_modal_layout-module__header--2CF1v","content":"restricted_modal_layout-module__content--21HBL","close":"restricted_modal_layout-module__close--1M_dd"};